import type { DayOfWeek, ScheduleConstraintCategory, ScheduleErrorTimeslot } from 'services/api';

export const checkTimeslotViolation = ({
  dayOfWeek,
  startTime,
  endTime,
  educationalClassId,
  highlightedErrors,
}: {
  dayOfWeek: DayOfWeek;
  educationalClassId: number;
  startTime: string;
  endTime: string;
  highlightedErrors: ScheduleErrorTimeslot[] | null;
}): {
  isError: boolean;
  category?: ScheduleConstraintCategory;
  errors?: ScheduleErrorTimeslot[];
} => {
  if (!highlightedErrors) {
    return { isError: false };
  }

  const errors = highlightedErrors.filter(
    (e) =>
      e.dayOfWeek === dayOfWeek &&
      e.startTime === startTime &&
      e.endTime === endTime &&
      e.educationalClass.id === educationalClassId,
  );

  let category: ScheduleConstraintCategory | undefined;

  errors.forEach((e) => {
    if (category !== 'LOGICAL') {
      category = e.category;
    }
  });

  if (!errors?.length) {
    return { isError: false };
  }
  return {
    isError: !!errors.length,
    category,
    errors,
  };
};
